import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";
import { useSpaceDisplayName } from "./useSpaceDisplayName";

export function useSpaceName(): (id: string) => string {
  const [spaces] = useQuery(queries.spacesLite({ includeAdminSpaces: true }));
  const displaySpaceName = useSpaceDisplayName();
  return (id) => {
    const space = spaces.find((space) => space.id === id);
    return space ? displaySpaceName(space) : "Restricted space";
  };
}
